import { Address } from './address.model';
import { UsageRightPaymentModel } from '@markant-platform/usage-right/model';

export type BookingRequestType = 'ORDER_REQUEST' | 'UPGRADE_REQUEST' | 'DEMO_REQUEST';

export enum OrganizationType {
  DEALER = 'DEALER',
  SUPPLIER = 'SUPPLIER',
}

export interface OrganizationDetailData {
  id?: string;
  customerNumber?: number;
  organizationId?: string;
  name: string;
  gln: string;
  address: Address;
  phone?: string;
  salesTaxId?: string;
  taxNumber?: string;
  commercialRegisterId?: string;
  commercialRegister?: string;
  naceCode?: string;
  paymentInformation?: PaymentInformation;
  paymentModel?: UsageRightPaymentModel;
  contact?: string;
  contactMail?: string;
  organizationType?: OrganizationType;
  status?: OrganizationStatus;
  state?: string;
  createdAt?: string;
  validityPeriodStart?: string;
  validityPeriodEnd?: string;
  version?: number;
  ezrCustomer: boolean;
  openFurtherQualificationProcess?: boolean;
  qualificationLevel: QualificationLevel | null;
  validatedGlns?: string[];
  billingEmail?: string;
  masterKin?: string;
  furtherKins?: string[];
  markantOrganization?: boolean;
  crmId?: string;
  industry?: Industry;
  markantId?: string;
  billingLanguageIsoCode?: string;
  reason?: string;
  leadContext?: string;
  bookingId?: string;
}

export interface OrganizationMembership {
  organizationId: string;
  organizationName: string;
  phone?: string;
  position?: string;
  department?: string;
  userOrganizationStatus: string;
  becameActiveAt?: Date | null;
  createdAt?: Date;
}

export interface PaymentInformation {
  iban: string;
  bic: string;
  bank: string;
}

export enum OrganizationStatus {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

export enum Industry {
  DEALER = 'DEALER',
  SUPPLIER = 'SUPPLIER',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
  OTHER = 'OTHER',
}

export enum QualificationLevel {
  LEVEL_1 = 'LEVEL_1',
  LEVEL_2 = 'LEVEL_2',
  LEVEL_3 = 'LEVEL_3',
}
